import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldCheck } from "lucide-react";
import {
  ArrowLeft,
  XCircle,
  RefreshCw,
  CheckCircle,
  AlertTriangle,
  Shield,
  Mail,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import mainlogo from "@/assets/mylistiq-logo-new.png";
import CallToActionFooter from "@/components/Footer";
// import CallingBot from "./Callingbot";
// import Chatbot from "./Chatbot";
import BotLauncher from "@/components/BotLauncher";
const RefundPolicy = () => {
  const location = useLocation();

  const isContactPage = location.pathname === "/contact";
  const isTermsPage =
    location.pathname === "/terms" ||
    location.pathname === "/terms-and-conditions";
  const isRefundPage =
    location.pathname === "/refund-policy" || location.pathname === "/refund";
  const isLoggedIn = !!localStorage.getItem("access_token");

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <header className="sticky top-0 z-50 backdrop-blur-md bg-gradient-to-b  from-blue-100/90 to-blue-50/90">
        {/* Gradient bottom line */}
        <div className="h-[1.5px] w-full bg-gradient-to-r from-transparent to-transparent" />

        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <Link
                to="/"
                onClick={(e) => {
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
                className="flex items-center gap-2"
              >
                <img
                  src={mainlogo}
                  alt="MyListIQ"
                  className="h-12 w-auto drop-shadow-sm"
                />
              </Link>
            </div>

            {/* Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                Features
              </Link>

              <Link
                to="/"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                Pricing
              </Link>

              <Link
                to="/about"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                About
              </Link>

              {/* CTA Button */}
              <Button
                asChild
                size="sm"
                className="
            text-base font-semibold
            bg-gradient-to-r from-blue-600 to-indigo-600
            hover:from-blue-700 hover:to-indigo-700
            shadow-md hover:shadow-xl
            transition-all
          "
              >
                <Link
                  to={
                    localStorage.getItem("access_token")
                      ? "/dashboard"
                      : "/signup"
                  }
                >
                  {localStorage.getItem("access_token")
                    ? "Dashboard"
                    : "Sign Up"}
                </Link>
              </Button>

            </div>
          </div>
        </div>
      </header>


      <div className="space-y-10">
        <Card className="p-6 md:p-8 lg:p-10 bg-card/80 backdrop-blur-xl border border-border/40 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500">
          <CardContent className="p-0">
            <div className="space-y-7 text-muted-foreground text-base md:text-[17px] leading-relaxed">

              {/* AGREEMENT */}
              <section className="pt-3 pb-2 px-0">
                <div className="max-w-5xl mx-auto">
                  {/* Hero Section */}
                  <div className="text-center space-y-6 mb-20">
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#2563eb]/10 animate-pulse">
                      <Shield className="h-12 w-12 text-[#2563eb]" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-[#2563eb]">
                      PRIVACY POLICY
                    </h1>

                  </div>

                  <div className="space-y-10">



                  </div>

                </div>
              </section>

              <div className="max-w-4xl mx-auto pt-8">
                <section className="space-y-5">
                  <p>Last Updated: April 2026</p>
                  <h2 className="text-xl sm:text-2xl font-bold text-foreground">
                    AGREEMENT TO OUR PRIVACY NOTICE
                  </h2>

                  <p>
                    This Privacy Notice for{" "}
                    <strong className="text-foreground">MyListIQ, LLC</strong> ("we",
                    "us", or "our") describes how and why we might access, collect, store,
                    use, and/or share ("process") your personal information when you use
                    our services ("Services"), including when you:
                  </p>

                  <ul className="space-y-3 pl-6 list-disc">
                    <li>
                      Visit our website at{" "}
                      <a className="text-blue-600 hover:underline" href="http://mylistiq.com">
                        http://mylistiq.com
                      </a>{" "}
                      or any website of ours that links to this Privacy Notice
                    </li>
                    <li>
                      Use our platform:{" "}
                      <strong className="text-foreground">
                        Marketing by Email Made Simple
                      </strong>
                      . Create and launch professional flyers in minutes. AI powers
                      scroll-stopping subject lines, compelling descriptions, and
                      enhanced photos. Instantly schedule distribution through built-in
                      email hubs, your own custom hub, or across social platforms — while
                      intelligent analytics track opens, clicks, optimized send times,
                      and predictive performance so you can measure and scale success.
                    </li>
                    <li>
                      Engage with us in other related ways, including any marketing or
                      events
                    </li>
                  </ul>

                  <p>
                    <strong className="text-foreground">Questions or concerns?</strong>{" "}
                    Reading this Privacy Notice will help you understand your privacy
                    rights and choices. We are responsible for making decisions about how
                    your personal information is processed. If you do not agree with our
                    policies and practices, please do not use our Services. If you still
                    have questions, please contact us at{" "}
                    <a className="text-blue-600 hover:underline" href="mailto:support@mylistiq.com">
                      support@mylistiq.com 
                    </a> or call us at <a className="text-blue-600 hover:underline" href="tel:+13215194247">+1 (321) 519-4247</a> 
                    .
                  </p>
                </section>


                <hr className="border-border/70" />

                {/* SUMMARY */}
                <section className="space-y-5">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-6">
                    SUMMARY OF KEY POINTS
                  </h2>

                  <p>
                    This summary provides key points from our Privacy Notice. You can
                    find more details about any of these topics by clicking the links
                    below or by using the table of contents.
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      <strong className="text-foreground">
                        What personal information do we process?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#infocollect">
                        See section 1
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">
                        Do we process any sensitive personal information?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#infocollect">
                        See section 1
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">
                        Do we collect any information from third parties?
                      </strong>{" "}
                      → <strong className="text-foreground">No</strong>, we do not
                      collect information from third parties.
                    </li>
                    <li>
                      <strong className="text-foreground">
                        How do we process your information?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#infouse">
                        See section 2
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">
                        In what situations and with which types of parties do we share
                        personal information?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#whoshare">
                        See section 3
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">
                        How do we keep your information safe?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#infosafe">
                        See section 8
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">What are your rights?</strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#privacyrights">
                        See section 10
                      </a>
                    </li>
                    <li>
                      <strong className="text-foreground">
                        How do you exercise your rights?
                      </strong>{" "}
                      →{" "}
                      <a className="text-blue-600 hover:underline" href="#request">
                        See section 16
                      </a>
                    </li>
                  </ul>
                </section>

                <hr className="border-border/70" />

                {/* TOC (same style as your Terms page TOC) */}
                <section className="space-y-6">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8 uppercase">
                    TABLE OF CONTENTS
                  </h2>

                  <ol className="space-y-3 text-base">
                    {[
                      ["infocollect", "WHAT INFORMATION DO WE COLLECT?"],
                      ["infouse", "HOW DO WE PROCESS YOUR INFORMATION?"],
                      [
                        "whoshare",
                        "WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?",
                      ],
                      ["cookies", "DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?"],
                      ["ai", "DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?"],
                      ["sociallogins", "HOW DO WE HANDLE YOUR SOCIAL LOGINS?"],
                      ["inforetain", "HOW LONG DO WE KEEP YOUR INFORMATION?"],
                      ["infosafe", "HOW DO WE KEEP YOUR INFORMATION SAFE?"],
                      ["infominors", "DO WE COLLECT INFORMATION FROM MINORS?"],
                      ["privacyrights", "WHAT ARE YOUR PRIVACY RIGHTS?"],
                      ["DNT", "CONTROLS FOR DO-NOT-TRACK FEATURES"],
                      ["uslaws", "DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?"],
                      ["sms", "SMS AND EMAIL COMMUNICATIONS AND CONSENT"],
                      ["clausea", "EMAIL MARKETING PRIVACY"],
                      ["policyupdates", "DO WE MAKE UPDATES TO THIS NOTICE?"],
                      ["contact", "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"],
                      ["request", "HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?"],
                    ].map(([id, label], idx) => (
                      <li key={id} className="flex items-baseline gap-2">
                        <span className="text-muted-foreground min-w-[28px]">
                          {idx + 1}.
                        </span>
                        <a
                          href={`#${id}`}
                          className="text-blue-600 hover:underline uppercase"
                        >
                          {label}
                        </a>
                      </li>
                    ))}
                  </ol>
                </section>

                <hr className="border-border/70" />

                {/* 1 */}
                <section id="infocollect" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    1. WHAT INFORMATION DO WE COLLECT?
                  </h2>

                  <h3 className="text-2xl font-bold text-foreground">
                    Personal information you disclose to us
                  </h3>
                  <p>
                    <strong className="text-foreground">In Short:</strong> We collect
                    personal information that you provide to us.
                  </p>

                  <p>
                    We collect personal information that you voluntarily provide to us
                    when you register on the Services, express an interest in obtaining
                    information about us or our products and Services, participate in
                    activities on the Services, or otherwise contact us.
                  </p>

                  <p>
                    <strong className="text-foreground">
                      Personal Information Provided by You.
                    </strong>{" "}
                    The personal information we collect may include the following:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>names</li>
                    <li>phone numbers</li>
                    <li>email addresses</li>
                    <li>mailing addresses</li>
                    <li>contact preferences</li>
                    <li>billing addresses</li>
                    <li>debit/credit card numbers</li>
                    <li>job titles</li>
                    <li>usernames</li>
                    <li>passwords</li>
                    <li>contact or authentication data</li>
                    <li>brokerage firm</li>
                    <li>photos</li>
                    <li>contact list "my hub"</li>
                  </ul>

                  <p>
                    <strong className="text-foreground">Sensitive Information.</strong>{" "}
                    When necessary, with your consent or as otherwise permitted by
                    applicable law, we process the following categories of sensitive
                    information:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>payment information</li>
                  </ul>

                  <p>
                    <strong className="text-foreground">Payment Data.</strong> We may
                    collect data necessary to process your payment if you make purchases.
                    All payment data is handled and stored by{" "}
                    <strong className="text-foreground">Stripe</strong>. You may find
                    their privacy notice here:{" "}
                    <a
                      className="text-blue-600 hover:underline"
                      href="https://stripe.com/privacy"
                    >
                      https://stripe.com/privacy
                    </a>
                    .
                  </p>

                  <p>
                    <strong className="text-foreground">Social Media Login Data.</strong>{" "}
                    We may provide you with the option to register or log in using your
                    existing social media account details (like Facebook or X). If you
                    choose to do this, we will receive certain profile information from
                    your social media provider (name, email address, friends list,
                    profile picture, etc.).
                  </p>

                  <h3 className="text-lg sm:text-xl font-bold text-foreground">
                    Information automatically collected
                  </h3>
                  <p>
                    <strong className="text-foreground">In Short:</strong> Some
                    information — such as your IP address and/or browser and device
                    characteristics — is collected automatically when you visit our
                    Services.
                  </p>

                  <p>
                    We automatically collect certain information when you visit, use, or
                    navigate the Services. This information may include:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      <strong className="text-foreground">Log and Usage Data</strong> —
                      IP address, device information, browser type, pages viewed,
                      time/date stamps, etc.
                    </li>
                    <li>
                      <strong className="text-foreground">Device Data</strong> — IP
                      address, device ID, browser type, hardware model, operating system,
                      etc.
                    </li>
                    <li>
                      <strong className="text-foreground">Location Data</strong> — Device
                      location (precise or approximate). You can opt out by refusing
                      access or disabling location settings on your device.
                    </li>
                  </ul>

                  <h3 className="text-2xl font-bold text-foreground">Google API</h3>
                  <p>
                    Our use of information received from Google APIs adheres to the{" "}
                    <a
                      className="text-blue-600 hover:underline"
                      href="https://developers.google.com/terms/api-services-user-data-policy"
                    >
                      Google API Services User Data Policy
                    </a>
                    , including the Limited Use requirements.
                  </p>
                </section>

                {/* 2 */}
                <section id="infouse" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    2. HOW DO WE PROCESS YOUR INFORMATION?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We process
                    your information to provide, improve, and administer our Services,
                    communicate with you, for security and fraud prevention, and to
                    comply with law. We may also process your information for other
                    purposes with your consent.
                  </p>

                  <p>
                    We process your personal information for a variety of reasons,
                    depending on how you interact with our Services, including:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>To facilitate account creation and authentication</li>
                    <li>To respond to user inquiries / offer support</li>
                    <li>To send administrative information to you</li>
                    <li>To request feedback</li>
                    <li>To send marketing and promotional communications</li>
                    <li>To deliver targeted advertising</li>
                    <li>
                      To evaluate and improve our Services, products, marketing, and your
                      experience
                    </li>
                    <li>To identify usage trends</li>
                    <li>To determine the effectiveness of marketing campaigns</li>
                  </ul>
                </section>

                {/* 3 */}
                <section id="whoshare" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We may share
                    information in specific situations described in this section and/or
                    with the following third parties.
                  </p>

                  <p>
                    We may need to share your personal information in the following
                    situations:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      <strong className="text-foreground">Business Transfers.</strong>{" "}
                      We may share or transfer your information in connection with, or
                      during negotiations of, any merger, sale of company assets,
                      financing, or acquisition of all or a portion of our business to
                      another company.
                    </li>
                    <li>
                      <strong className="text-foreground">Business Partners.</strong> We
                      may share your information with our business partners to offer you
                      certain products, services, or promotions.
                    </li>
                  </ul>
                </section>

                {/* 4 */}
                <section id="cookies" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We may use
                    cookies and other tracking technologies to collect and store your
                    information.
                  </p>

                  <p>
                    We may use cookies and similar tracking technologies (like web
                    beacons and pixels) to gather information when you interact with our
                    Services. Some online tracking technologies help us maintain the
                    security of our Services and your account, prevent crashes, fix bugs,
                    save your preferences, and assist with basic site functions.
                  </p>
                </section>

                {/* 5 */}
                <section id="ai" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    5. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We offer
                    products, features, or tools powered by artificial intelligence,
                    machine learning, or similar technologies.
                  </p>

                  <p>
                    As part of our Services, we offer products, features, or tools
                    powered by artificial intelligence, machine learning, or similar
                    technologies (collectively, "AI Products"). These tools are designed
                    to enhance your experience and provide you with innovative solutions.
                    The terms in this Privacy Notice govern your use of the AI Products
                    within our Services.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Use of AI Technologies
                  </h3>
                  <p>
                    We provide the AI Products through third-party service providers
                    ("AI Service Providers"), including OpenAI. As outlined in this
                    Privacy Notice, your input, output, and personal information will be
                    shared with and processed by these AI Service Providers to enable
                    your use of our AI Products for purposes outlined in "HOW DO WE
                    PROCESS YOUR INFORMATION?" You must not use the AI Products in any
                    way that violates the terms or policies of any AI Service Provider.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">Our AI Products</h3>
                  <p>Our AI Products are designed for the following functions:</p>
                  <ul className="space-y-2 pl-6 list-disc">
                    <li>Email subject line generation</li>
                    <li>Content creation and optimization</li>
                    <li>Image enhancement</li>
                    <li>Predictive analytics</li>
                  </ul>

                  <h3 className="text-2xl font-bold text-foreground">
                    How We Process Your Data Using AI
                  </h3>
                  <p>
                    All personal information processed using our AI Products is handled
                    in line with our Privacy Notice and our agreement with third parties.
                    This ensures high security and safeguards your personal information
                    throughout the process, giving you peace of mind about your data's
                    safety.
                  </p>
                </section>

                {/* 6 */}
                <section id="sociallogins" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> If you choose
                    to register or log in to our Services using a social media account,
                    we may have access to certain information about you.
                  </p>

                  <p>
                    Our Services offer you the ability to register and log in using your
                    third-party social media account details (like your Facebook or X
                    logins). Where you choose to do this, we will receive certain profile
                    information about you from your social media provider. The profile
                    information we receive may vary depending on the social media
                    provider concerned, but will often include your name, email address,
                    friends list, and profile picture, as well as other information you
                    choose to make public on such a social media platform.
                  </p>
                </section>

                {/* 7 */}
                <section id="inforetain" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    7. HOW LONG DO WE KEEP YOUR INFORMATION?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We keep your
                    information for as long as necessary to fulfill the purposes outlined
                    in this Privacy Notice unless otherwise required by law.
                  </p>

                  <p>
                    We will only keep your personal information for as long as it is
                    necessary for the purposes set out in this Privacy Notice, unless a
                    longer retention period is required or permitted by law (such as tax,
                    accounting, or other legal requirements).
                  </p>

                  <p>
                    When we have no ongoing legitimate business need to process your
                    personal information, we will either delete or anonymize such
                    information, or, if this is not possible (for example, because your
                    personal information has been stored in backup archives), then we
                    will securely store your personal information and isolate it from
                    any further processing until deletion is possible.
                  </p>
                </section>

                {/* 8 */}
                <section id="infosafe" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    8. HOW DO WE KEEP YOUR INFORMATION SAFE?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We aim to
                    protect your personal information through a system of organizational
                    and technical security measures.
                  </p>

                  <p>
                    We have implemented appropriate and reasonable technical and
                    organizational security measures designed to protect the security of
                    any personal information we process. However, despite our safeguards
                    and efforts to secure your information, no electronic transmission
                    over the Internet or information storage technology can be
                    guaranteed to be 100% secure, so we cannot promise or guarantee that
                    hackers, cybercriminals, or other unauthorized third parties will
                    not be able to defeat our security and improperly collect, access,
                    steal, or modify your information. Although we will do our best to
                    protect your personal information, transmission of personal
                    information to and from our Services is at your own risk. You should
                    only access the Services within a secure environment.
                  </p>
                </section>

                {/* 9 */}
                <section id="infominors" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    9. DO WE COLLECT INFORMATION FROM MINORS?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> We do not
                    knowingly collect data from or market to children under 18 years of
                    age.
                  </p>

                  <p>
                    We do not knowingly collect, solicit data from, or market to
                    children under 18 years of age, nor do we knowingly sell such
                    personal information. By using the Services, you represent that you
                    are at least 18 or that you are the parent or guardian of such a
                    minor and consent to such minor dependent's use of the Services.
                  </p>
                </section>

                {/* 10 */}
                <section id="privacyrights" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    10. WHAT ARE YOUR PRIVACY RIGHTS?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> Depending on
                    your state of residence in the US or in some regions, such as the
                    European Economic Area (EEA), United Kingdom (UK), Switzerland, and
                    Canada, you have rights that allow you greater access to and control
                    over your personal information.
                  </p>

                  <p>
                    In some regions (like the EEA, UK, Switzerland, and Canada), you have
                    certain rights under applicable data protection laws. These may
                    include the right (i) to request access and obtain a copy of your
                    personal information, (ii) to request rectification or erasure;
                    (iii) to restrict the processing of your personal information; (iv)
                    if applicable, to data portability; and (v) not to be subject to
                    automated decision-making. In certain circumstances, you may also
                    have the right to object to the processing of your personal
                    information.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Withdrawing your consent
                  </h3>
                  <p>
                    If we are relying on your consent to process your personal
                    information, you have the right to withdraw your consent at any
                    time. You can withdraw your consent at any time by contacting us
                    using the contact details provided in the section "HOW CAN YOU
                    CONTACT US ABOUT THIS NOTICE?" below.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Account Information
                  </h3>
                  <p>
                    If you would at any time like to review or change the information in
                    your account or terminate your account, you can:
                  </p>
                  <ul className="space-y-2 pl-6 list-disc">
                    <li>Log in to your account settings and update your user account.</li>
                    <li>Contact us using the contact information provided.</li>
                  </ul>
                  <p>To unsubscribe from email communications, you may use the unsubscribe link contained in any marketing email, 
                    complete the unsubscribe process on our website at mylistiq.com, or email support@mylistiq.com with the subject line "UNSUBSCRIBE" and 
                    the email address you wish to remove.</p>
                </section>

                {/* 11 */}
                <section id="DNT" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    11. CONTROLS FOR DO-NOT-TRACK FEATURES
                  </h2>

                  <p>
                    Most web browsers and some mobile operating systems and mobile
                    applications include a Do-Not-Track ("DNT") feature or setting you
                    can activate to signal your privacy preference not to have data
                    about your online browsing activities monitored and collected. At
                    this stage, no uniform technology standard for recognizing and
                    implementing DNT signals has been finalized. As such, we do not
                    currently respond to DNT browser signals or any other mechanism that
                    automatically communicates your choice not to be tracked online. If
                    a standard for online tracking is adopted that we must follow in the
                    future, we will inform you about that practice in a revised version
                    of this Privacy Notice.
                  </p>
                </section>

                {/* 12 */}
                <section id="uslaws" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> If you are a
                    resident of California, Colorado, Connecticut, Delaware, Florida,
                    Indiana, Iowa, Kentucky, Montana, New Hampshire, New Jersey, Oregon,
                    Tennessee, Texas, Utah, or Virginia, you may have the right to
                    request access to and receive details about the personal information
                    we maintain about you and how we have processed it, correct
                    inaccuracies, get a copy of, or delete your personal information.
                    You may also have the right to withdraw your consent to our
                    processing of your personal information. These rights may be limited
                    in some circumstances by applicable law.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Categories of Personal Information We Collect
                  </h3>
                  <p>
                    We have collected the following categories of personal information in
                    the past twelve (12) months:
                  </p>

                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-border/60">
                      <thead>
                        <tr className="bg-muted/40">
                          <th className="border border-border/60 p-3 text-left font-bold text-foreground">
                            Category
                          </th>
                          <th className="border border-border/60 p-3 text-left font-bold text-foreground">
                            Examples
                          </th>
                          <th className="border border-border/60 p-3 text-left font-bold text-foreground">
                            Collected
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-base">
                        <tr>
                          <td className="border border-border/60 p-3">A. Identifiers</td>
                          <td className="border border-border/60 p-3">
                            Contact details, such as real name, alias, postal address,
                            telephone or mobile contact number, unique personal
                            identifier, online identifier, Internet Protocol address,
                            email address, and account name
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            B. Personal information as defined in the California Customer
                            Records statute
                          </td>
                          <td className="border border-border/60 p-3">
                            Name, contact information, education, employment, employment
                            history, and financial information
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            C. Protected classification characteristics under state or
                            federal law
                          </td>
                          <td className="border border-border/60 p-3">
                            Gender, age, date of birth, race and ethnicity, national
                            origin, marital status, and other demographic data
                          </td>
                          <td className="border border-border/60 p-3">NO</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            D. Commercial information
                          </td>
                          <td className="border border-border/60 p-3">
                            Transaction information, purchase history, financial
                            details, and payment information
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            E. Biometric information
                          </td>
                          <td className="border border-border/60 p-3">
                            Fingerprints and voiceprints
                          </td>
                          <td className="border border-border/60 p-3">NO</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            F. Internet or other similar network activity
                          </td>
                          <td className="border border-border/60 p-3">
                            Browsing history, search history, online behavior, interest
                            data, and interactions with our and other websites,
                            applications, systems, and advertisements
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            G. Geolocation data
                          </td>
                          <td className="border border-border/60 p-3">Device location</td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            H. Audio, electronic, sensory, or similar information
                          </td>
                          <td className="border border-border/60 p-3">
                            Images and audio, video or call recordings created in
                            connection with our business activities
                          </td>
                          <td className="border border-border/60 p-3">NO</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            I. Professional or employment-related information
                          </td>
                          <td className="border border-border/60 p-3">
                            Business contact details in order to provide you our Services
                            at a business level or job title, work history, and
                            professional qualifications if you apply for a job with us
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            J. Education Information
                          </td>
                          <td className="border border-border/60 p-3">
                            Student records and directory information
                          </td>
                          <td className="border border-border/60 p-3">NO</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            K. Inferences drawn from collected personal information
                          </td>
                          <td className="border border-border/60 p-3">
                            Inferences drawn from any of the collected personal
                            information listed above to create a profile or summary
                            about, for example, an individual's preferences and
                            characteristics
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                        <tr>
                          <td className="border border-border/60 p-3">
                            L. Sensitive personal Information
                          </td>
                          <td className="border border-border/60 p-3">
                            Account login information, drivers' licenses, state
                            identification cards, passport numbers, and payment card
                            numbers
                          </td>
                          <td className="border border-border/60 p-3">YES</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <p>
                    We may also collect other personal information outside of these
                    categories through instances where you interact with us in person,
                    online, or by phone or mail in the context of:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>Receiving help through our customer support channels;</li>
                    <li>Participation in customer surveys or contests; and</li>
                    <li>
                      Facilitation in the delivery of our Services and to respond to your
                      inquiries.
                    </li>
                  </ul>

                  <h3 className="text-2xl font-bold text-foreground">
                    Sources of Personal Information
                  </h3>
                  <p>
                    Learn more about the sources of personal information we collect in
                    "WHAT INFORMATION DO WE COLLECT?"
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    How We Use and Share Personal Information
                  </h3>
                  <p>
                    Learn more about how we use your personal information in the section,
                    "HOW DO WE PROCESS YOUR INFORMATION?"
                  </p>

                  <p>
                    <strong className="text-foreground">
                      Will your information be shared with anyone else?
                    </strong>
                  </p>

                  <p>
                    We may disclose your personal information with our service providers
                    pursuant to a written contract between us and each service provider.
                    Learn more about how we disclose personal information to in the
                    section, "WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?"
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">Your Rights</h3>
                  <p>
                    You have rights under certain US state data protection laws. However,
                    these rights are not absolute, and in certain cases, we may decline
                    your request as permitted by law. These rights include:
                  </p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      <strong className="text-foreground">Right to know</strong> whether
                      or not we are processing your personal data
                    </li>
                    <li>
                      <strong className="text-foreground">Right to access</strong> your
                      personal data
                    </li>
                    <li>
                      <strong className="text-foreground">Right to correct</strong>{" "}
                      inaccuracies in your personal data
                    </li>
                    <li>
                      <strong className="text-foreground">Right to request</strong> the
                      deletion of your personal data
                    </li>
                    <li>
                      <strong className="text-foreground">Right to obtain a copy</strong>{" "}
                      of the personal data you previously shared with us
                    </li>
                    <li>
                      <strong className="text-foreground">Right to non-discrimination</strong>{" "}
                      for exercising your rights
                    </li>
                    <li>
                      <strong className="text-foreground">Right to opt out</strong> of
                      the processing of your personal data if it is used for targeted
                      advertising (or sharing as defined under California's privacy law),
                      the sale of personal data, or profiling in furtherance of decisions
                      that produce legal or similarly significant effects ("profiling")
                    </li>
                  </ul>

                  <h3 className="text-2xl font-bold text-foreground">
                    How to Exercise Your Rights
                  </h3>
                  <p>
                    To exercise these rights, you can contact us by submitting a{" "}
                    <a
                      className="text-blue-600 hover:underline"
                      href="https://app.termly.io/dsar/8e95b3b7-d605-41e9-9e2a-930cb5c63173"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      data subject access request
                    </a>
                    , by emailing us at{" "}
                    <a className="text-blue-600 hover:underline" href="mailto:support@mylistiq.com">
                      support@mylistiq.com
                    </a>
                    , or by calling us at <a className="text-blue-600 hover:underline" href="tel:+13215194247">+1 (321) 519-4247</a> 
                    .
                  </p>
                </section>


                {/* SMS */}
                <section id="sms" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    13. SMS AND EMAIL COMMUNICATIONS AND CONSENT
                  </h2>
                  <p>
                    Consent to receive SMS and email communications is not required as a condition of purchasing any
                    goods or services from MyListIQ. Opt-in consent is collected via a single, explicit, unchecked
                    checkbox and is independent of any other terms of service or purchase agreement with MyListIQ.
                  </p>

                  {/* <p>
                    <strong className="text-foreground">In Short:</strong> By providing
                    your phone number during registration, you consent to receive SMS
                    text message notifications from MyListIQ. You can opt out at any
                    time by replying STOP.
                  </p> */}

                  <h3 className="text-2xl font-bold text-foreground">
                    How We Collect Consent
                  </h3>
                  <p>
                    We collect your mobile phone number, email address, and communications consent during account
                    registration or at any point you submit a phone number or email address. Consent is obtained via a
                    single, explicit, unchecked checkbox. You are not enrolled in SMS or email marketing communications
                    unless you affirmatively check this box.
                  </p>

                  <p>
                   Consent Checkbox Language:
                  </p>
                  <p></p>

                  <p className="text-base text-gray-600 leading-relaxed mb-4">
                    By checking this box, I provide my consent for MyListIQ, LLC to send me text messages (SMS) to the
                    phone number provided and commercial electronic mail messages to the email address provided,
                    including promotional, transactional, and informational communications. I understand that my consent
                    is not a condition of purchase, and that message and data rates may apply for SMS. Reply{" "}
                    <strong className="text-foreground">STOP</strong> to opt out of SMS or{" "}
                    <strong className="text-foreground">HELP</strong> for assistance at any time. I have read and agree
                    to the Privacy Policy and Terms and Conditions.
                  </p>

                  {/* <p>Checkbox 2 (Optional): I agree to receive promotional and marketing SMS messages from MyListIQ at the phone number provided. Msg & data rates may apply. Reply HELP for help, or STOP to cancel at any time. This includes:</p>

                  <ul className="space-y-2 pl-6 list-disc">
                    <li>Promotional offers and announcements</li>
                    <li>Special deals and discounts</li>
                    <li>New feature and product updates</li>
                    <li>Marketing communications from MyListIQ</li>
                  </ul> */}
           


                  {/* <p>Checking Checkbox 1 is required for account creation, as it covers essential service notifications only. Checkbox 2 is strictly optional. Each consent is independent. We will never send marketing or promotional SMS messages to users who have only completed Checkbox 1.</p> */}
                  <h3 className="text-2xl font-bold text-foreground">
                    Types of Communications We Send
                  </h3>
                  {/* <p>
                   Once you have opted in, MyListIQ may send SMS text messages to the phone number you provided, based on your consent selection:
                  </p> */}
                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      Promotional — offers, announcements, discounts, and marketing communications.
                    </li>
                    <li>
                      Transactional — registration confirmations, purchase confirmations, account notifications.
                    </li>
                    <li>
                      Informational — campaign status updates, new feature announcements, service notifications.
                    </li>
                  </ul>


                  <h3 className="text-2xl font-bold text-foreground">
                    Consent Is Not Required
                  </h3>
                  <p>
                 Consent to receive SMS or email communications is not a condition of registration, account creation, or purchase.
                  You may register and use the Services without consenting to receive any SMS or marketing email notifications.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Third-Party Delivery
                  </h3>
                  <p>
                    We may use third-party service providers to facilitate the delivery of SMS and email communications. 
                    These providers are contractually obligated to handle your data in accordance with this Privacy Policy.

                  </p>

                  <p>No mobile information will be shared with third parties or affiliates for marketing or promotional
                    purposes. All the above categories exclude text messaging originator opt-in data and consent; this
                    information will not be shared with any third parties.

                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Message Frequency
                  </h3>
                  <p>
                    Message frequency may vary based on your account activity and the campaigns you run through the Services.{" "}
                    You will only receive messages directly related to your account, campaigns, or promotional offers you have consented to receive.
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    Message and Data Rates
                  </h3>
                  <p>
                   Message and data rates may apply. Message frequency may vary. Rates are determined by your mobile carrier and the specifics of your mobile plan. 
                   MyListIQ, LLC is not responsible for any charges imposed by your carrier.

                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    How to Opt Out
                  </h3>
                  <p>
                    To opt out of SMS, reply{" "}
                    <strong className="text-foreground">STOP</strong> to any SMS message from MyListIQ,LLC.You will receive the following confirmation: "You have been successfully unsubscribed from MyListIQ. No further messages will be sent." Reply <strong className="text-foreground">START</strong> to resubscribe." 
                    <p className="mt-4">To opt out of email marketing communications, you may:</p>
                   
                    <ul className="space-y-2 pl-6 list-disc mt-2">

                    <li>Click the unsubscribe link in any marketing email you receive, which may redirect you to mylistiq.com where an unsubscribe confirmation modal will appear. 
                      Confirm your email address and click "Unsubscribe me" to be removed from future email communications</li>
                    <li>If the unsubscribe modal does not appear, send an email to support@mylistiq.com with the subject line "UNSUBSCRIBE" and include the email address you wish to remove in the body of the email. If you are emailing from a different address than the one you wish to unsubscribe,
                       clearly identify both the sending email address and the email address to be removed.</li>
                    
                  </ul>
                  <p className="mt-2">Removal requests will be processed promptly upon receipt and are permanent unless you choose to re-subscribe.</p>

                    {/* <a className="text-blue-600 hover:underline"
                      href="mailto:support@mylistiq.com"
                    > support@mylistiq.com
                    </a> */}
                 
                  </p>

                  <h3 className="text-2xl font-bold text-foreground">
                    What Happens After Unsubscribing
                  </h3>

                  <p>Once your unsubscribe request is processed through either method described above, 
                    you will no longer receive marketing, promotional, informational, or future email communications from MyListIQ. No further action is required on your part.</p>


                  <p>Unsubscribed email addresses may be retained on a suppression 
                    list solely for the purpose of ensuring that no future communications are sent to those addresses unless the recipient subsequently re-subscribes.</p>

                  <h3 className="text-2xl font-bold text-foreground">Support</h3>
                  <p>
                    Reply <strong className="text-foreground">HELP</strong> to any SMS
                    message for assistance, or contact us at{" "}

                    <a className="text-blue-600 hover:underline"
                      href="mailto:support@mylistiq.com"
                    >
                      support@mylistiq.com
                    </a>
                    .
                  </p>

                  
                </section>

                {/* 14 */}
                <section id="clausea" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    14. EMAIL MARKETING PRIVACY
                  </h2>

                  <p>When you use MyListIQ to send marketing emails, you are responsible for:</p>
                  <ul className="space-y-2 pl-6 list-disc">
                    <li>Ensuring all recipients have provided consent to receive emails</li>
                    <li>Complying with CAN-SPAM, GDPR, and other applicable email marketing laws</li>
                    <li>Maintaining accurate contact lists</li>
                    <li>Honoring unsubscribe requests promptly</li>
                  </ul>

                  <p>
                    <strong className="text-foreground">How We Handle Email Data:</strong>
                  </p>
                  <ul className="space-y-2 pl-6 list-disc">
                    <li>
                      Email addresses you upload are stored securely and used only for the purpose of sending your campaigns
                    </li>
                    <li>We do not sell, rent, or share your contact lists with third parties</li>
                    <li>Recipient engagement data (opens, clicks, etc.) is accessible only to you through your dashboard</li>
                    <li>We may use aggregated, anonymized data to improve our Services</li>
                  </ul>
                </section>

                {/* 15 */}
                <section id="policyupdates" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    15. DO WE MAKE UPDATES TO THIS NOTICE?
                  </h2>

                  <p>
                    <strong className="text-foreground">In Short:</strong> Yes, we will
                    update this notice as necessary to stay compliant with relevant laws.
                  </p>

                  <p>
                    We may update this Privacy Notice from time to time. The updated
                    version will be indicated by an updated "Last updated" date at the
                    top of this Privacy Notice. If we make material changes to this
                    Privacy Notice, we may notify you either by prominently posting a
                    notice of such changes or by directly sending you a notification. We
                    encourage you to review this Privacy Notice frequently to be
                    informed of how we are protecting your information.
                  </p>
                </section>

                {/* 16 */}
                <section id="contact" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    16. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                  </h2>

                  <p>
                    If you have questions or comments about this notice, you may email us
                    at{" "}
                    <a className="text-blue-600 hover:underline" href="mailto:support@mylistiq.com">
                      support@mylistiq.com
                    </a>{" "}
                    or contact us by post at:
                  </p>

                  <p className="text-muted-foreground">
                    <strong className="text-foreground">MyListIQ, LLC</strong>
                    <br />
                    5366 Central Florida Pkwy #1015
                    <br />
                    Orlando, FL 32821
                    <br />
                    United States
                  </p>
                </section>

                {/* 17 */}
                <section id="request" className="space-y-4 scroll-mt-24">
                  <h2 className="text-3xl font-bold text-foreground mb-4 mt-8">
                    17. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
                  </h2>

                  <p>
                    Based on the applicable laws of your country or state of residence in
                    the US, you may have the right to request access to the personal
                    information we collect from you, correct inaccuracies, or delete your
                    personal information.
                  </p>

                  <p>
                    To request to review, update, or delete your personal information,
                    please submit a data subject access request, email us at{" "}
                    <a className="text-blue-600 hover:underline" href="mailto:support@mylistiq.com">
                      support@mylistiq.com
                    </a>
                    , or visit{" "}
                    <a className="text-blue-600 hover:underline" href="https://mylistiq.com/contact">
                      https://mylistiq.com/contact
                    </a>
                    .
                  </p>
                </section>

              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* <Chatbot />
      <CallingBot /> */}
      <CallToActionFooter />
      <BotLauncher />
    </div>
  );
};

export default RefundPolicy;
